(function () {
  'use strict';

  var CROPPER_CSS = 'https://cdnjs.cloudflare.com/ajax/libs/cropperjs/1.6.2/cropper.min.css';
  var CROPPER_JS  = 'https://cdnjs.cloudflare.com/ajax/libs/cropperjs/1.6.2/cropper.min.js';
  var IMG_ICON = '<svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="3" y="3" width="18" height="18" rx="3"/><circle cx="8.5" cy="9" r="1.7"/><path d="M21 16l-4.5-4.5L6 21"/></svg><span class="pod-plus">+</span>';

  function qa(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }

  // Registry dùng chung cho fetch hook: mỗi block POD đăng ký 1 api ở đây
  window._pod = window._pod || { blocks: [], hooked: false };

  function init() {
    qa('[data-pod]').forEach(setup);
    installFetchHook();
  }

  // ============================================================
  // SETUP 1 BLOCK
  // ============================================================
  function setup(root) {
    if (root.dataset.podReady) return; root.dataset.podReady = '1';

    var cfg = {
      endpoint: root.dataset.endpoint, token: root.dataset.token,
      match: (root.dataset.match || '').trim().toLowerCase(),
      productUrl: (root.dataset.productUrl || '').split('?')[0],
      variantIds: (root.dataset.variantIds || '').split(/[\s,]+/).filter(Boolean),
      maxBytes: (parseFloat(root.dataset.maxMb) || 15) * 1024 * 1024
    };

    // --- Tìm đúng form sản phẩm (tránh nhầm form ebook/upsell) ---
    var form = root.closest('form[action*="/cart/add"]');
    if (!form) {
      var section = root.closest('.shopify-section, [data-section-id], [data-section-type]');
      form = section && section.querySelector('form[action*="/cart/add"]');
    }
    if (!form) {
      var all = qa('form[action*="/cart/add"]'), rr = root.getBoundingClientRect(), best = null, bd = Infinity;
      all.forEach(function (f) {
        var fr = f.getBoundingClientRect(), d = Math.abs(fr.top - rr.top) + Math.abs(fr.left - rr.left);
        if (d < bd) { bd = d; best = f; }
      });
      form = best;
    }
    if (!form) return;

    var cropModal = root.querySelector('.pod-modal');
    var imageCtrls = [];

    function anyUploading() { return imageCtrls.some(function (c) { return c.isUploading(); }); }
    function refreshBuy() {
      var d = anyUploading();
      form.querySelectorAll('[name="add"], [type="submit"]').forEach(function (b) {
        b.disabled = d; b.classList.toggle('disabled', d);
      });
    }

    // --- Build field controllers từ DOM ---
    var ctrls = qa('.pod-field', root).map(function (el) {
      return el.dataset.type === 'image'
        ? makeImage(el, cfg, cropModal, refreshBuy, imageCtrls)
        : makeText(el);
    });

    function collectProps() {
      var props = {}, urls = [], ids = [];
      ctrls.forEach(function (c) {
        var p = c.getProp(); for (var k in p) { if (p[k] !== '' && p[k] != null) props[k] = p[k]; }
      });
      imageCtrls.forEach(function (c) {
        c.doneImages().forEach(function (i) { if (i.url) urls.push(i.url); if (i.driveId) ids.push(i.driveId); });
      });
      if (urls.length) props['_image_urls'] = urls.join('\n');
      if (ids.length)  props['_image_ids']  = ids.join('\n');
      return props;
    }
    function validateAll() { var ok = true; ctrls.forEach(function (c) { if (!c.validate()) ok = false; }); return ok; }

    // ============ VARIANT GATING ============
    var variantMap = null;

    function currentVariant() {
      var urlV = new URLSearchParams(location.search).get('variant');
      if (urlV) return String(urlV);
      if (variantMap) {
        var ids = Object.keys(variantMap), inputs = document.querySelectorAll('[name="id"]');
        for (var i = 0; i < inputs.length; i++) {
          if (ids.indexOf(String(inputs[i].value)) > -1) return String(inputs[i].value);
        }
      }
      var inp = form.querySelector('[name="id"]');
      return inp ? String(inp.value) : '';
    }

    function isCustomVariant() {
      var id = currentVariant();
      if (!id) return !cfg.variantIds.length && !cfg.match;
      if (cfg.variantIds.length && cfg.variantIds.indexOf(id) > -1) return true;
      if (cfg.match) {
        var v = variantMap && variantMap[id];
        if (v) {
          var hay = ((v.title || '') + ' ' + [v.option1, v.option2, v.option3].filter(Boolean).join(' ') + ' ' + (v.sku || '')).toLowerCase();
          if (hay.indexOf(cfg.match) > -1) return true;
        }
        return variantMap ? false : true; // chưa load map → tạm hiện
      }
      return !cfg.variantIds.length;
    }

    function applyVisible() { root.hidden = !isCustomVariant(); }

    var lastKey = '';
    function checkV() {
      var key = currentVariant() + '|' + location.search;
      if (key !== lastKey) { lastKey = key; applyVisible(); }
    }

    form.addEventListener('change', checkV);
    window.addEventListener('popstate', checkV);
    setInterval(checkV, 400); // catch-all cho Shrine Pro (đổi variant qua pushState)

    if (cfg.productUrl) {
      fetch(cfg.productUrl + '.js').then(function (r) { return r.json(); }).then(function (p) {
        variantMap = {}; (p.variants || []).forEach(function (v) { variantMap[String(v.id)] = v; });
      }).catch(function () {}).then(applyVisible);
    }
    applyVisible();

    // ============ VALIDATE khi bấm ATC ============
    form.querySelectorAll('[name="add"], [type="submit"]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        if (root.hidden) return;
        if (anyUploading() || !validateAll()) { e.preventDefault(); e.stopImmediatePropagation(); }
      }, true);
    });

    // ============ Đăng ký vào registry cho fetch hook ============
    window._pod.blocks.push({
      variantId: currentVariant,
      visible: function () { return !root.hidden; },
      props: collectProps
    });
  }

  // ============================================================
  // FETCH HOOK — inject properties vào đúng /cart/add request
  //   chỉ khi: id khớp variant đang chọn + block đang hiện.
  //   Ebook / variant Standard sẽ KHÔNG khớp -> không dính props.
  // ============================================================
  function installFetchHook() {
    if (window._pod.hooked) return; window._pod.hooked = true;
    var orig = window.fetch;
    window.fetch = function (res, init) {
      try {
        var url = typeof res === 'string' ? res : (res && res.url) || '';
        if (init && init.body && /\/cart\/add(\.js)?(\?|$)/.test(url)) {
          var id = itemIdOf(init.body), match = null;
          for (var i = 0; i < window._pod.blocks.length; i++) {
            var b = window._pod.blocks[i];
            if (b.visible() && String(b.variantId()) === String(id)) { match = b; break; }
          }
          if (match) init = injectProps(init, match.props());
        }
      } catch (e) {}
      return orig.call(this, res, init);
    };
  }

  function itemIdOf(body) {
    try {
      if (typeof FormData !== 'undefined' && body instanceof FormData) return String(body.get('id') || '');
      if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) return String(body.get('id') || '');
      if (typeof body === 'string') { var p = JSON.parse(body); return String((p.items && p.items[0] && p.items[0].id) || p.id || ''); }
    } catch (e) {}
    return '';
  }

  function injectProps(init, props) {
    var body = init.body, k;
    if ((typeof FormData !== 'undefined' && body instanceof FormData) ||
        (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams)) {
      for (k in props) if (props[k] !== '' && props[k] != null) body.set('properties[' + k + ']', props[k]);
      return init;
    }
    if (typeof body === 'string') {
      try {
        var p = JSON.parse(body), add = {};
        for (k in props) if (props[k] !== '' && props[k] != null) add[k] = props[k];
        if (Array.isArray(p.items) && p.items.length) p.items[0].properties = Object.assign({}, p.items[0].properties || {}, add);
        else p.properties = Object.assign({}, p.properties || {}, add);
        return Object.assign({}, init, { body: JSON.stringify(p) });
      } catch (e) {}
    }
    return init;
  }

  // ============================================================
  // FIELD: text / paragraph
  // ============================================================
  function makeText(el) {
    var title = el.dataset.title || 'Custom';
    var required = el.dataset.required === 'true';
    var input = el.querySelector('.pod-input');
    input.addEventListener('input', function () { el.classList.remove('pod-invalid'); });
    return {
      isUploading: function () { return false; },
      doneImages: function () { return []; },
      getProp: function () { var o = {}; o[title] = input.value.trim(); return o; },
      validate: function () { if (required && !input.value.trim()) { el.classList.add('pod-invalid'); return false; } return true; }
    };
  }

  // ============================================================
  // FIELD: image
  // ============================================================
  function makeImage(el, cfg, cropModal, refreshBuy, imageCtrls) {
    var title = el.dataset.title || 'Image';
    var required = el.dataset.required === 'true';
    var maxImages = parseInt(el.dataset.maxImages) || 1;
    var ratio = computeRatio(el.dataset.ratio, el.dataset.w, el.dataset.h);
    var drops = el.querySelector('.pod-drops');
    var images = [], uploadCount = 0, seq = 0;
    var storeKey = 'pod:' + (cfg.productUrl || location.pathname) + ':' + title;

    function doneImages() { return images.filter(function (i) { return i.status === 'done'; }); }

    function render() {
      drops.innerHTML = '';
      images.forEach(function (it) {
        var d = document.createElement('div');
        d.className = 'pod-drop pod-filled' + (it.status === 'uploading' ? ' pod-busy' : '') + (it.status === 'error' ? ' pod-derr' : '');
        d.innerHTML = '<img src="' + it.preview + '"><button type="button" class="pod-rmimg">✕</button>';
        d.querySelector('.pod-rmimg').onclick = function () {
          images = images.filter(function (a) { return a.id !== it.id; }); render(); persist();
        };
        drops.appendChild(d);
      });
      if (images.length < maxImages) {
        var add = document.createElement('div'); add.className = 'pod-drop'; add.title = 'Upload image';
        add.innerHTML = IMG_ICON; add.onclick = pick;
        add.addEventListener('dragenter', function (e) { e.preventDefault(); add.classList.add('pod-dragover'); });
        add.addEventListener('dragover', function (e) { e.preventDefault(); add.classList.add('pod-dragover'); });
        add.addEventListener('dragleave', function () { add.classList.remove('pod-dragover'); });
        add.addEventListener('drop', function (e) {
          e.preventDefault(); add.classList.remove('pod-dragover');
          var f = e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0]; if (f) handle(f);
        });
        drops.appendChild(add);
      }
    }
    function pick() {
      var inp = document.createElement('input'); inp.type = 'file'; inp.accept = 'image/*';
      inp.onchange = function () { var f = inp.files[0]; if (f) handle(f); };
      inp.click();
    }
    function handle(file) {
      if (!/^image\//.test(file.type)) return;
      readAsDataURL(file).then(function (du) { return cropImage(cropModal, du, ratio); }).then(function (cu) {
        if (!cu) return;
        var item = { id: ++seq, preview: cu, url: '', driveId: '', status: 'uploading' };
        images.push(item); el.classList.remove('pod-invalid'); render();
        if (!cfg.endpoint) { item.status = 'done'; render(); persist(); return; }
        uploadCount++; refreshBuy();
        return shrink(cu, file, cfg.maxBytes).then(function (out) {
          return fetch(cfg.endpoint, {
            method: 'POST', headers: { 'Content-Type': 'text/plain;charset=utf-8' },
            body: JSON.stringify({ action: 'upload', token: cfg.token, dataBase64: out.base64, mimeType: out.mime, filename: file.name })
          }).then(function (r) { return r.json(); });
        }).then(function (res) {
          if (!res.ok) throw new Error(res.error || 'upload failed');
          item.url = res.url; item.driveId = res.fileId; item.status = 'done';
        }).catch(function () { item.status = 'done'; })
          .then(function () { uploadCount--; refreshBuy(); render(); persist(); });
      });
    }
    function persist() {
      try { localStorage.setItem(storeKey, JSON.stringify(doneImages().map(function (i) { return { p: i.preview, u: i.url, d: i.driveId }; }))); } catch (e) {}
    }
    function restore() {
      try {
        (JSON.parse(localStorage.getItem(storeKey) || '[]')).forEach(function (o) {
          images.push({ id: ++seq, preview: o.p, url: o.u || '', driveId: o.d || '', status: 'done' });
        });
      } catch (e) {}
    }
    restore(); render();

    var ctrl = {
      isUploading: function () { return uploadCount > 0; },
      doneImages: doneImages,
      getProp: function () { var o = {}; o[title] = doneImages().map(function (i) { return i.url; }).filter(Boolean).join(', '); return o; },
      validate: function () { if (required && !doneImages().length) { el.classList.add('pod-invalid'); return false; } return true; }
    };
    imageCtrls.push(ctrl);
    return ctrl;
  }

  // ============================================================
  // CROP
  // ============================================================
  function cropImage(modal, dataUrl, ratio) {
    return loadCropper().then(function () {
      return new Promise(function (resolve) {
        var img = modal.querySelector('.pod-crop-img');
        img.src = dataUrl; modal.hidden = false;
        var cropper = new Cropper(img, { aspectRatio: ratio, viewMode: 1, autoCropArea: 1, background: false });
        function close(r) { cropper.destroy(); modal.hidden = true; modal.removeEventListener('click', onClick); resolve(r); }
        function onClick(e) {
          var act = e.target.getAttribute('data-c'); if (!act) return;
          if (act === 'rotl') cropper.rotate(-90);
          else if (act === 'rotr') cropper.rotate(90);
          else if (act === 'reset') cropper.reset();
          else if (act === 'cancel') close(null);
          else if (act === 'submit') close(cropper.getCroppedCanvas({ maxWidth: 4000, maxHeight: 4000, imageSmoothingQuality: 'high' }).toDataURL('image/jpeg', 0.95));
        }
        modal.addEventListener('click', onClick);
      });
    });
  }

  // ============================================================
  // HELPERS
  // ============================================================
  function computeRatio(r, w, h) {
    w = parseFloat(w); h = parseFloat(h);
    if (w > 0 && h > 0) return w / h;
    if (!r || r === 'free') return NaN;
    var p = r.split(':'), v = parseFloat(p[0]) / parseFloat(p[1]); return isFinite(v) && v > 0 ? v : NaN;
  }
  function readAsDataURL(file) {
    return new Promise(function (res, rej) { var r = new FileReader(); r.onload = function () { res(r.result); }; r.onerror = rej; r.readAsDataURL(file); });
  }
  function shrink(dataUrl, file, maxBytes) {
    var raw = dataUrl.split(',')[1];
    if (raw.length * 0.75 <= maxBytes) return Promise.resolve({ base64: raw, mime: dataUrl.substring(5, dataUrl.indexOf(';')) || file.type });
    return new Promise(function (res) {
      var img = new Image();
      img.onload = function () {
        var max = 4000, w = img.width, h = img.height;
        if (Math.max(w, h) > max) { var s = max / Math.max(w, h); w = Math.round(w * s); h = Math.round(h * s); }
        var c = document.createElement('canvas'); c.width = w; c.height = h; c.getContext('2d').drawImage(img, 0, 0, w, h);
        var q = 0.92, out = c.toDataURL('image/jpeg', q);
        while (out.length * 0.75 > maxBytes && q > 0.5) { q -= 0.1; out = c.toDataURL('image/jpeg', q); }
        res({ base64: out.split(',')[1], mime: 'image/jpeg' });
      };
      img.onerror = function () { res({ base64: raw, mime: file.type }); };
      img.src = dataUrl;
    });
  }
  var cropperPromise;
  function loadCropper() {
    if (window.Cropper) return Promise.resolve();
    if (cropperPromise) return cropperPromise;
    cropperPromise = new Promise(function (res, rej) {
      var l = document.createElement('link'); l.rel = 'stylesheet'; l.href = CROPPER_CSS; document.head.appendChild(l);
      var s = document.createElement('script'); s.src = CROPPER_JS; s.onload = res; s.onerror = rej; document.head.appendChild(s);
    });
    return cropperPromise;
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
